import { create } from "zustand"

export type ManagementType = "self" | "member" | null

export interface StateTypes {
  enabledSteps: boolean[]
  management: ManagementType
  bookConsult: boolean
  actionKeys: string[]
}

export interface ActionTypes {
  setEnabledSteps: (enabledSteps: boolean[]) => void
  setManagement: (management: ManagementType) => void
  setBookConsult: (bookConsult: boolean) => void
  setActionKeys: (action: string) => void
  setMultipleActionKeys: (actionKeys: string[]) => void
}

export type GovernmentStoreTypes = StateTypes & ActionTypes

export const initialState: StateTypes = {
  enabledSteps: [true, false, false, false, false],
  management: null,
  bookConsult: false,
  actionKeys: [],
}

export const useGovernmentStore = create<GovernmentStoreTypes>((set, get) => ({
  ...initialState,

  setEnabledSteps: (enabledSteps) => set({ enabledSteps }),
  setManagement: (management) => set({ management }),
  setBookConsult: (bookConsult) => set({ bookConsult }),
  setActionKeys: (action) => {
    const currentKeys = get().actionKeys
    const exists = currentKeys.includes(action)

    set({
      actionKeys: exists
        ? currentKeys.filter((key) => key !== action) // remove if exists
        : [...currentKeys, action], // add if not
    })
  },
  setMultipleActionKeys: (newKeys: string[]) => {
    set({ actionKeys: newKeys })
  },
}))
